import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const SquareLineIcon = ({ size, className, ...other }) => (
  /* eslint-disable */

  <div
    className={clsx(
      "em-c-icon",
      {
        "em-c-icon--small": size === "small",
        "em-c-icon--medium": size !== "small" && size !== "large",
        "em-c-icon--large": size === "large"
      },
      "em-icon-wrapper",
      className
    )}
    {...other}
  >
    {size === "small" ? (
      <svg height="100%" width="100%" viewBox="0 0 16 16">
        <path d="M13 13H3V3h10zm-8-2h6V5H5z" fill="currentColor" />
      </svg>
    ) : size === "large" ? (
      <svg height="100%" width="100%" viewBox="0 0 48 48">
        <path d="M41 41H7V7h34zm-31-3h28V10H10z" fill="currentColor" />
      </svg>
    ) : (
      <svg height="100%" width="100%" viewBox="0 0 24 24">
        <path d="M21 21H3V3h18zM6 18h12V6H6z" fill="currentColor" />
      </svg>
    )}
  </div>

  /* eslint-enable */
);

SquareLineIcon.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** className allows you to append css classes */

  className: PropTypes.string
};

SquareLineIcon.defaultProps = {
  size: "medium",

  className: ""
};

export default SquareLineIcon;
